export const general = {
  actions: {
    success: 'Cambios guardados exitosamente',
  },
  title: 'Información General',
  labelName: 'Nombre',
  labelDescription: 'Descripción',
  save: 'Guardar',
}

export const item = {
  somethingWentWrong: 'Algo salió mal',
  requestRemoval: 'Solicitar devolución',
  rentItem: 'Alquilar ítem',
  itemForRent: 'Este ítem está publicado en nuestra comunidad',
  itemNotForRent: 'Este ítem no está publicado en nuestra comunidad',
  rentForHowMuch: '¿A cuánto quieres alquilar este ítem?',
  perDay: '/día',
  save: 'Guardar',
}

export const rent = {
  actions: {
    success: 'Cambios guardados exitosamente',
  },
  rent: 'Alquilar',
  labelForRent: 'En alquiler',
  labelPricePerDay: 'Precio de alquiler por día',
  save: 'Guardar',
}



// WEBPACK FOOTER //
// ./src/sections/yourItems/text.js